module.exports = __webpack_public_path__ + "static/media/icon-height.6c39d5da.svg";